export interface SupportChannelConfig {
  email: string;
  whatsappNumber: string;
  whatsappFormatted: string;
  whatsappMessage: string;
  whatsappUrl: string;
}

export const SUPPORT_CONFIG: SupportChannelConfig = {
  email: 'suporte@eclesys.com',
  whatsappNumber: '553197028129',
  whatsappFormatted: '(31) 97028129',
  whatsappMessage: 'Olá, sou cliente do Plano Anual do Eclesys e preciso de suporte',
  whatsappUrl: 'https://wa.me/553197028129?text=Ol%C3%A1%2C%20sou%20cliente%20do%20Plano%20Anual%20do%20Eclesys%20e%20preciso%20de%20suporte'
};
